import scssVariables from '@/assets/scss/_variables.scss'
import { hexToRgb } from '@/helpers/Utils'

export default {
    setGlobalColors (primaryHex, secondaryHex, fontHex, iconPrimaryHex, iconSecondaryHex) {
        if (null != primaryHex) {
            document.documentElement.style.setProperty('--dynamic-primary', primaryHex)
            document.documentElement.style.setProperty('--dynamic-primary-rgb', hexToRgb(primaryHex))
        } else {
            document.documentElement.style.setProperty('--dynamic-primary', scssVariables.primaryDefault)
            document.documentElement.style.setProperty('--dynamic-primary-rgb', hexToRgb(scssVariables.primaryDefault))
        }
        if (null != secondaryHex) {
            document.documentElement.style.setProperty('--dynamic-secondary', secondaryHex)
            document.documentElement.style.setProperty('--dynamic-secondary-rgb', hexToRgb(secondaryHex))
        } else {
            document.documentElement.style.setProperty('--dynamic-secondary', scssVariables.secondaryDefault)
            document.documentElement.style.setProperty('--dynamic-secondary-rgb', hexToRgb(scssVariables.secondaryDefault))
        }
        if (null != fontHex) {
            document.documentElement.style.setProperty('--dynamic-font', fontHex)
        } else {
            document.documentElement.style.setProperty('--dynamic-font', scssVariables.fontDefault)
        }
        if (null != iconPrimaryHex) {
            document.documentElement.style.setProperty('--dynamic-icon-primary', iconPrimaryHex)
            document.documentElement.style.setProperty('--dynamic-icon-primary-rgb', hexToRgb(iconPrimaryHex))
        } else {
            document.documentElement.style.setProperty('--dynamic-icon-primary', scssVariables.iconPrimaryDefault)
        }
        if (null != iconSecondaryHex) {
            document.documentElement.style.setProperty('--dynamic-icon-secondary', iconSecondaryHex)
            document.documentElement.style.setProperty('--dynamic-icon-secondary-rgb', hexToRgb(iconSecondaryHex))
        } else {
            document.documentElement.style.setProperty('--dynamic-icon-secondary', scssVariables.iconSecondaryDefault)
        }
    },
    resetGlobalColors () {
        document.documentElement.style.setProperty('--dynamic-primary', scssVariables.primaryDefault)
        document.documentElement.style.setProperty('--dynamic-primary-rgb', hexToRgb(scssVariables.primaryDefault))
        document.documentElement.style.setProperty('--dynamic-secondary', scssVariables.secondaryDefault)
        document.documentElement.style.setProperty('--dynamic-secondary-rgb', hexToRgb(scssVariables.secondaryDefault))
        document.documentElement.style.setProperty('--dynamic-icon-primary', scssVariables.iconPrimaryDefault)
        document.documentElement.style.setProperty('--dynamic-icon-primary-rgb', hexToRgb(scssVariables.iconPrimaryDefault))
        document.documentElement.style.setProperty('--dynamic-icon-secondary', scssVariables.iconSecondaryDefault)
        document.documentElement.style.setProperty('--dynamic-icon-secondary-rgb', hexToRgb(scssVariables.iconSecondaryDefault))
        document.documentElement.style.setProperty('--dynamic-font', scssVariables.fontDefault)
    }
}
